import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfGetAllScoresResponseDto } from '../../dtos/scores/self-get-all-scores.response.dto';
import { GetSelfCalendarScoreQuery } from '../../queries/scores/get-self-calendar-score.query';
import { GetSelfFocusScoreQuery } from '../../queries/scores/get-self-focus-score.query';
import { GetSelfTimeInCallsScoreQuery } from '../../queries/scores/get-self-time-in-calls-score.query';
import { GetSelfDigitalWorkingHoursScoreQuery } from '../../queries/scores/get-self-digital-working-hours-score.query';
import { GetSelfScreentimeScoreQuery } from '../../queries/scores/get-self-screentime-score.query';
import { SelfCalendarScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-calendar-score.aggregate-root';
import { SelfFocusScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-focus-score.aggregate-root';
import { SelfDigitalWorkingHoursScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-working-hours-score.aggregate-root';
import { SelfTimeInCallsScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-time-in-calls-score.aggregate-root';
import { SelfScreentimeScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-screentime-score.aggregate-root';
import { SelfDigitalIntensityScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-intensity-score.aggregate-root';
import { GetSelfDigitalIntensityScoreQuery } from '../../queries/scores/get-self-digital-intensity-score.query';
import { GetSelfAllScoresPresenter } from '../../presenters/scores/get-self-all-scores.presenter';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfAllScoresCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly getSelfCalendarScoreQuery: GetSelfCalendarScoreQuery,
    protected readonly getSelfFocusScoreQuery: GetSelfFocusScoreQuery,
    protected readonly getSelfDigitalWorkingHoursScoreQuery: GetSelfDigitalWorkingHoursScoreQuery,
    protected readonly getSelfTimeInCallsScoreQuery: GetSelfTimeInCallsScoreQuery,
    protected readonly getSelfScreentimeScoreQuery: GetSelfScreentimeScoreQuery,
    protected readonly getSelfDigitalIntensityScoreQuery: GetSelfDigitalIntensityScoreQuery,
    protected readonly presenter: GetSelfAllScoresPresenter
  ) {}

  async get(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfGetAllScoresResponseDto> {
    try {
      const calendarScorePromise: Promise<SelfCalendarScoreAggregateRoot> =
        this.getSelfCalendarScoreQuery.execute(props);
      const focusScorePromise: Promise<SelfFocusScoreAggregateRoot> =
        this.getSelfFocusScoreQuery.execute(props);

      const digitalWorkingHoursScorePromise: Promise<SelfDigitalWorkingHoursScoreAggregateRoot> =
        this.getSelfDigitalWorkingHoursScoreQuery.execute(props);

      const timeInCallsScorePromise: Promise<SelfTimeInCallsScoreAggregateRoot> =
        this.getSelfTimeInCallsScoreQuery.execute(props);

      const screentimeScorePromise: Promise<SelfScreentimeScoreAggregateRoot> =
        this.getSelfScreentimeScoreQuery.execute(props);

      const digitalIntensityScorePromise: Promise<SelfDigitalIntensityScoreAggregateRoot> =
        this.getSelfDigitalIntensityScoreQuery.execute(props);

      const [
        calendarScore,
        focusScore,
        digitalWorkingHoursScore,
        timeInCallsScore,
        screentimeScore,
        digitalIntensityScore,
      ] = await Promise.all([
        calendarScorePromise,
        focusScorePromise,
        digitalWorkingHoursScorePromise,
        timeInCallsScorePromise,
        screentimeScorePromise,
        digitalIntensityScorePromise,
      ]);

      const response = this.presenter.toResponse({
        calendarScore,
        focusScore,
        digitalWorkingHoursScore,
        timeInCallsScore,
        screentimeScore,
        digitalIntensityScore,
      });

      return {
        ...response,
        startDate: props.params.startDate,
        endDate: props.params.endDate,
      };
    } catch (error) {
      throw new Error(
        `GetSelfAllScoresCompositeController.get encountered an error ${error}`
      );
    }
  }
}
